<!-- Compiled at 2026-05-13T13:50:05.286Z -->
<ng-container *ngIf="$isVariablesInitialized()">
	<ng-container *lowgileScope="null; screen: this; let $scope">
		<ng-container *lowgileForm="null; screen: this; let $formDirective">
			<div style="display: contents" [class.fill]="false">
				<div
					class="layout-block vertical"
					[style.align-items]="'inherit'"
					[style.gap]="'1em'"
				>
					<div
						class="layout-block"
						[style.align-items]="'inherit'"
						[class.horizontal]="Sys.Layout.sizeIsGreaterThanOrEqual.XSmall"
						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
						[style.gap]="'1em'"
					>
						<h3
							[innerHtml]="This.$T.myTasks | escapeHtml: 'none' | replaceNewlines: 'h3'"
						></h3>
						<span
							[style.flex]="'1 0 auto'"
							[innerHtml]="'' | escapeHtml: 'none' | replaceNewlines: 'span'"
						></span>
						<button
							mat-icon-button
							class="has-click-handler"
							color="basic"
							(click)="handler_ButtonBlock_27_click_reloadTasks_0($event, {  })"
							[disabled]="$disabled"
						>
							<mat-icon>{{'refresh'}}</mat-icon>
						</button>
					</div>
					<lowgile-table
						#datatable_8
						[dataSignal]="_DataTableBlock_collectionCodeSignal_8(datatable_8, { app, screen, $pathSegments, $disabled })"
						[trackBy]="trackByAutomatic"
						[entity]="Sys.Types.UserTaskToken"
						[columns]="_DataTableBlock_columns_8(screen)"
						[showSettings]="true"
						[userDefinedConfiguration]="undefined"
						[usePaging]="true"
						[pageSize]="20"
						[pageSizeOptions]="[10, 20, 50]"
						[useGlobalFilter]="false"
						[debouncingDelay]="250"
						[stickyHeader]="true"
						[additionalFindOptions]="null"
						[additionalHeaderRows]="[]"
						[additionalFooterRows]="[]"
						[allClasses]="$Modules"
						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
						[surroundingScope]="$scope"
						class="has-rowClick-handler"
						(rowClick)="handler_DataTableBlock_8_rowClick_onTaskClick_0($event, {  })"
						#$table_8="lowgileTable"
					>
						<ng-container [lowgile-column]="'taskName'">
							<th mat-header-cell *matHeaderCellDef>
								<span
									[innerHtml]="This.$T.taskName | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</th>
							<td
								mat-cell
								*matCellDef="let item; let index = index"
								[attr.data-label]="This.$T.taskName"
							>
								<ng-container *lowgileScope="item; as: 'item'; let $scope">
									<ng-container *lowgileScope="index; as: 'index'; let $scope">
										<span
											[innerHtml]="_DataTableColumnBlock_cellText_9({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</ng-container>
								</ng-container>
							</td>
						</ng-container>
						<ng-container [lowgile-column]="('taskName') + '$$filter'">
							<th mat-header-cell *matHeaderCellDef></th>
						</ng-container>
					</lowgile-table>
					<h3
						[innerHtml]="This.$T.myTeamTasks | escapeHtml: 'none' | replaceNewlines: 'h3'"
					></h3>
					<lowgile-table
						#datatable_11
						[dataSignal]="_DataTableBlock_collectionCodeSignal_11(datatable_11, { app, screen, $pathSegments, $disabled })"
						[trackBy]="trackByAutomatic"
						[entity]="Sys.Types.UserTaskToken"
						[columns]="_DataTableBlock_columns_11(screen)"
						[showSettings]="true"
						[userDefinedConfiguration]="undefined"
						[usePaging]="true"
						[pageSize]="20"
						[pageSizeOptions]="[10, 20, 50]"
						[useGlobalFilter]="false"
						[debouncingDelay]="250"
						[stickyHeader]="true"
						[additionalFindOptions]="null"
						[additionalHeaderRows]="[]"
						[additionalFooterRows]="[]"
						[allClasses]="$Modules"
						[class.vertical]="Sys.Layout.sizeIsLessThan.XSmall"
						[surroundingScope]="$scope"
						class="has-rowClick-handler"
						(rowClick)="handler_DataTableBlock_11_rowClick_onTaskClick_0($event, {  })"
						#$table_11="lowgileTable"
					>
						<ng-container [lowgile-column]="'taskName'">
							<th mat-header-cell *matHeaderCellDef>
								<span
									[innerHtml]="This.$T.taskName | escapeHtml: 'none' | replaceNewlines: 'span'"
								></span>
							</th>
							<td
								mat-cell
								*matCellDef="let item; let index = index"
								[attr.data-label]="This.$T.taskName"
							>
								<ng-container *lowgileScope="item; as: 'item'; let $scope">
									<ng-container *lowgileScope="index; as: 'index'; let $scope">
										<span
											[innerHtml]="_DataTableColumnBlock_cellText_12({ app, screen, $pathSegments, $disabled, item, index }) | escapeHtml: 'none' | replaceNewlines: 'span'"
										></span>
									</ng-container>
								</ng-container>
							</td>
						</ng-container>
						<ng-container [lowgile-column]="('taskName') + '$$filter'">
							<th mat-header-cell *matHeaderCellDef></th>
						</ng-container>
					</lowgile-table>
				</div>
			</div>
		</ng-container>
	</ng-container>
</ng-container>
